import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

import { useIsMobile } from 'utils/useIsMobile'

export const ChartContentLoader = () => {
  const theme = useTheme()
  const chartWidth = 1100
  const chartHeight = 560
  const xAxisY = 510
  const pointCount = 16
  const step = chartWidth / (pointCount - 1)

  const svgWidth = 1150
  const chartStartX = (svgWidth - chartWidth) / 2

  const points = Array.from({ length: pointCount }, (_, i) => {
    const x = chartStartX + i * step
    const y = 260 + Math.sin(i * 0.8) * 30 + Math.random() * 10
    return { x, y }
  })

  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y.toFixed(0)}`).join(' ')
  const areaPath = `${linePath} L ${points[points.length - 1].x} ${xAxisY} L ${points[0].x} ${xAxisY} Z`

  const buttonCount = 4
  const buttonWidth = 50
  const gap = 30
  const totalButtonsWidth = buttonCount * buttonWidth + (buttonCount - 1) * gap
  const buttonsStartX = (svgWidth - totalButtonsWidth) / 2

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={chartHeight}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      viewBox={`0 0 ${svgWidth} ${chartHeight}`}
      style={{ width: '100%', height: `${chartHeight}px` }}
    >
      {[0, 1, 2, 3].map(i => (
        <rect
          key={`btn-${i}`}
          x={buttonsStartX + i * (buttonWidth + gap)}
          y="20"
          rx="4"
          ry="4"
          width={buttonWidth}
          height="20"
        />
      ))}
      {points.map((point, i) => (
        <rect key={`tick-${i}`} x={point.x - 14} y={xAxisY + 10} rx="3" ry="3" width={28} height={10} />
      ))}

      <path d={areaPath} fill={theme.colors.contentLoader.foregroundColor} opacity="0.3" />
      <path d={linePath} stroke={theme.colors.contentLoader.foregroundColor} strokeWidth="2" fill="none" />

      <rect
        x={chartStartX}
        y={xAxisY}
        width={chartWidth}
        height="1.5"
        fill={theme.colors.contentLoader.backgroundColor}
      />

      <rect
        x={chartStartX + chartWidth}
        y="60"
        width="1.5"
        height={xAxisY - 60}
        fill={theme.colors.contentLoader.backgroundColor}
      />

      {Array.from({ length: 5 }, (_, i) => {
        const y = 60 + i * ((xAxisY - 60) / 4)
        return (
          <rect
            key={`y-tick-${i}`}
            x={chartStartX + chartWidth + 4}
            y={y - 5}
            width="20"
            height="10"
            rx="2"
            ry="2"
            fill={theme.colors.contentLoader.foregroundColor}
          />
        )
      })}
    </ContentLoader>
  )
}

export const ChartContentLoaderMobile = () => {
  const theme = useTheme()
  const chartWidth = 320
  const chartHeight = 360
  const chartStartX = 30
  const chartEndX = chartWidth - chartStartX
  const xAxisY = chartHeight - 50
  const pointCount = 8
  const step = (chartEndX - chartStartX) / (pointCount - 1)

  const points = Array.from({ length: pointCount }, (_, i) => {
    const x = chartStartX + i * step
    const y = 160 + Math.sin(i * 0.7) * 20 + Math.random() * 8
    return { x, y }
  })

  const linePath = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y.toFixed(0)}`).join(' ')
  const areaPath = `${linePath} L ${points[points.length - 1].x} ${xAxisY} L ${points[0].x} ${xAxisY} Z`

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={chartHeight}
      viewBox={`0 0 ${chartWidth} ${chartHeight}`}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      style={{ width: '100%', height: `${chartHeight}px` }}
    >
      {Array.from({ length: 4 }).map((_, i) => (
        <rect key={`btn-${i}`} x={chartWidth / 2 - 90 + i * 50} y="48" rx="4" ry="4" width="40" height="18" />
      ))}

      {points.map((point, i) => (
        <rect key={`tick-${i}`} x={point.x - 10} y={xAxisY + 6} rx="2" ry="2" width={20} height={8} />
      ))}

      <path d={areaPath} fill={theme.colors.contentLoader.foregroundColor} opacity="0.3" />
      <path d={linePath} stroke={theme.colors.contentLoader.foregroundColor} strokeWidth="1.5" fill="none" />
    </ContentLoader>
  )
}

export const PositionMetricHistoryContentLoaderResponsive = () => {
  const isMobile = useIsMobile()
  return isMobile ? <ChartContentLoaderMobile /> : <ChartContentLoader />
}
